'use strict';

module.exports = global;



/*****************
 ** WEBPACK FOOTER
 ** ./~/globalthis/implementation.js
 ** module id = 946
 ** module chunks = 0
 **/